import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { processSteps } from "@/mocks/home";

export default function Process() {
  return (
    <section id="process" className="border-y border-background-200/70 bg-background-100 py-16 md:py-28">
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-8">
        <Reveal>
          <SectionHeading
            kicker="How It Works"
            title="一条线索的四步旅程"
            description="从提交到反馈，每个环节都尽量轻量，尽量减少对投稿人的打扰，也尽量减少不必要的身份暴露。"
          />
        </Reveal>

        <ol className="mt-12 grid grid-cols-1 gap-8 md:mt-16 md:grid-cols-2 md:gap-x-12 md:gap-y-14 lg:grid-cols-4">
          {processSteps.map((step, index) => (
            <Reveal key={step.title} delay={index * 90}>
              <li className="flex flex-col">
                <div className="flex items-center gap-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-accent-100 font-heading text-lg text-accent-900">
                    {index + 1}
                  </span>
                  <span className="h-px flex-1 bg-background-300" />
                </div>
                <h3 className="mt-6 font-heading text-lg text-foreground-950">{step.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}